import { render } from "./main.vue?vue&type=template&id=088aa5f8&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=088aa5f8&scoped=true&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088aa5f8"]])

export default __exports__